
export const PERMISSIONS = {

  DASHBOARD_ACCESS: "dasb:v",

  CAF_MANAGE: "caf:m",
  OTT_MANAGE: "ott:m",

  // VAS and OTT Module Permissions (View + Manage)
  VAS_OTT_DIGITAL_SERVICES_VIEW: "vas-ott:dig-svc:v",
  VAS_OTT_DIGITAL_SERVICES_MANAGE: "vas-ott:dig-svc:m",
  VAS_OTT_VAS_PROVIDER_PACKAGES_VIEW: "vas-ott:vas-pkg:v",
  VAS_OTT_VAS_PROVIDER_PACKAGES_MANAGE: "vas-ott:vas-pkg:m",
  VAS_OTT_VAS_AGGREGATES_VIEW: "vas-ott:vas-agg:v",
  VAS_OTT_VAS_AGGREGATES_MANAGE: "vas-ott:vas-agg:m",
  VAS_OTT_BUNDLES_VIEW: "vas-ott:bnd:v",
  VAS_OTT_BUNDLES_MANAGE: "vas-ott:bnd:m",
  VAS_OTT_AUTO_ELIGIBILITY_VIEW: "vas-ott:auto-elg:v",
  VAS_OTT_AUTO_ELIGIBILITY_MANAGE: "vas-ott:auto-elg:m",
  VAS_OTT_CUSTOMERS_VIEW: "vas-ott:cus:v",
  VAS_OTT_CUSTOMERS_MANAGE: "vas-ott:cus:m",
  VAS_OTT_MANUAL_CONSOLE_VIEW: "vas-ott:man-con:v",
  VAS_OTT_MANUAL_CONSOLE_MANAGE: "vas-ott:man-con:m",
  VAS_OTT_COUPONS_VIEW: "vas-ott:cpn:v",
  VAS_OTT_COUPONS_MANAGE: "vas-ott:cpn:m",
  VAS_OTT_SOURCE_CONFIG_VIEW: "vas-ott:src-cfg:v",
  VAS_OTT_SOURCE_CONFIG_MANAGE: "vas-ott:src-cfg:m",
  VAS_OTT_AUDIT_VIEW: "vas-ott:adt:v",

  DOCKET_VIEW: "dct:dkt:v",
  DOCKET_CREATE: "dct:dkt:c",
  DOCKET_EDIT: "dct:dkt:e",
  DOCKET_CREATE_INTERNAL: "dct:dkt:int",
  DOCKET_CREATE_BROADBAND: "dct:dkt:bb",
  DOCKET_COMMENT_ADD: "dct:cmt:a",
  DOCKET_COMMENT_CUSTOMER: "dct:cmt:cus",
  DOCKET_ATTACHMENT_ADD: "dct:att:a",

  DOCKET_DEPARTMENT_VIEW: "dct:dept:v",
  DOCKET_DEPARTMENT_CREATE: "dct:dept:c",
  DOCKET_DEPARTMENT_EDIT: "dct:dept:e",

  DOCKET_DESIGNATION_VIEW: "dct:desg:v",
  DOCKET_DESIGNATION_CREATE: "dct:desg:c",
  DOCKET_DESIGNATION_EDIT: "dct:desg:e",

  DOCKET_OFFICE_VIEW: "dct:ofc:v",
  DOCKET_OFFICE_CREATE: "dct:ofc:c",
  DOCKET_OFFICE_EDIT: "dct:ofc:e",

  DOCKET_TEAM_VIEW: "dct:team:v",
  DOCKET_TEAM_CREATE: "dct:team:c",
  DOCKET_TEAM_EDIT: "dct:team:e",

  DOCKET_EMPLOYEE_VIEW: "dct:emp:v",
  DOCKET_EMPLOYEE_CREATE: "dct:emp:c",
  DOCKET_EMPLOYEE_EDIT: "dct:emp:e",

  OPERATIONS_CUSTOMER_VIEW: "ops:cus:v",
  OPERATIONS_ZONE_CUSTOMER_RENEW: "ops:cus:rnw",
  OPERATIONS_ZONE_CUSTOMER_UPGRADE: "ops:cus:upg",
  OPERATIONS_BROADBAND_CUSTOMER_RENEW: "ops:online-cus:rnw",
  OPERATIONS_BROADBAND_CUSTOMER_UPGRADE: "ops:online-cus:upg",
  OPERATIONS_WALLET_RECHARGE_MANAGE: "ops:zn-walt:m",
  OPERATIONS_ZONEPAY_TRANSACTION_VIEW: "ops:zn-txn:v",
  OPERATIONS_ZONEPAY_TRANSACTION_MANAGE: "ops:zn-txn:m",
  OPERATIONS_ONLINEPAY_TRANSACTION_VIEW: "ops:onp-txn:v",
  OPERATIONS_ONLINEPAY_TRANSACTION_MANAGE: "ops:onp-txn:m",
  OPERATIONS_BROADBAND_OTP_VIEW: "ops:bb-otp:v",


  ACCOUNTS_ZONE_STATEMENT_VIEW: "aco:zn-stmt:v",
  ACCOUNTS_CUSTOMER_RENEW_RECORD_VIEW: "aco:cus-rnw:v",
  ACCOUNTS_ZONE_BALANCE_VIEW: "aco:zn-bal:v",
  ACCOUNTS_ZONE_COMMISSION_VIEW: "aco:zn-comms:v",
  ACCOUNTS_ZONE_COMMISSION_MANAGE: "aco:zn-comms:m",
  ACCOUNTS_INVOICE_CANCEL: "aco:inv:d",
  ACCOUNTS_INVOICE_SYNC: "aco:inv-sync:m",
  ACCOUNTS_INVOICE_SYNC_COUNT_VIEW: "aco:inv-sync-cnt:v",
  ACCOUNTS_ORPHAN_INVOICE_VIEW: "aco:ophn-inv:v",
  ACCOUNTS_ADJUSTMENT_UPLOAD: "aco:data:upd",
  ACCOUNTS_ADJUSTMENT_DATA_VIEW: "aco:data:v",
  ACCOUNTS_ACTIVATION_REPORT: "aco:act-rpt:v",
  ACCOUNTS_TRANSACTION_REPORT: "txn:rpt:exp",

  NOTIFICATION_DASHBOARD_VIEW: "msg:dasb:v",
  NOTIFICATION_TEMPLATE_VIEW: "msg:tpl:v",
  NOTIFICATION_CHANNEL_ROUTE_VIEW: "msg:cnr:v",
  NOTIFICATION_EMAIL_CONFIG_VIEW: "msg:mail-cfg:v",
  NOTIFICATION_SMS_CONFIG_VIEW: "msg:sms-cfg:v",
  NOTIFICATION_PUSH_CONFIG_VIEW: "msg:push-cfg:v",
  NOTIFICATION_SEND: "msg:send",

  INVENTORY_ROLE_VIEW: "invt:role:v",
  INVENTORY_ROLE_MANAGE: "invt:role:m",
  INVENTORY_UOM_VIEW: "invt:uom:v",
  INVENTORY_UOM_MANAGE: "invt:uom:m",
  INVENTORY_VENDOR_VIEW: "invt:vendor:v",
  INVENTORY_VENDOR_MANAGE: "invt:vendor:m",
  INVENTORY_OFFICE_VIEW: "invt:office:v",
  INVENTORY_OFFICE_MANAGE: "invt:office:m",
  INVENTORY_EMPLOYEE_VIEW: "invt:emp:v",
  INVENTORY_EMPLOYEE_MANAGE: "invt:emp:m",
  INVENTORY_ITEM_MASTER_VIEW: "invt:item:v",
  INVENTORY_ITEM_MASTER_MANAGE: "invt:item:m",
  INVENTORY_ITEM_CATEGORY_VIEW: "invt:item-cat:v",
  INVENTORY_ITEM_CATEGORY_MANAGE: "invt:item-cat:m",
  INVENTORY_APPROVAL_MATRIX_VIEW: "invt:apr-mtx:v",
  INVENTORY_APPROVAL_MATRIX_MANAGE: "invt:apr-mtx:m",
  INVENTORY_REQUISITION_VIEW: "invt:reqn:v",
  INVENTORY_REQUISITION_MANAGE: "invt:reqn:m",
  INVENTORY_QUOTATION_VIEW: "invt:quot:v",
  INVENTORY_QUOTATION_MANAGE: "invt:quot:m",
  INVENTORY_PURCHASE_ORDER_VIEW: "invt:po:v",
  INVENTORY_PURCHASE_ORDER_MANAGE: "invt:po:m",
  INVENTORY_GRN_VIEW: "invt:grn:v",
  INVENTORY_GRN_MANAGE: "invt:grn:m",
  INVENTORY_STOCK_VIEW: "invt:stock:v",
  INVENTORY_STOCK_MANAGE: "invt:stock:m",
  INVENTORY_STOCK_ITEM_VIEW: "invt:stk-item:v",
  INVENTORY_STOCK_ITEM_MANAGE: "invt:stk-item:m",
  // Ledger is append-only -- every row is written by another module, so there is nothing to manage.
  INVENTORY_STOCK_LEDGER_VIEW: "invt:stk-ldg:v",
  INVENTORY_STOCK_TRANSFER_VIEW: "invt:stk-trf:v",
  INVENTORY_STOCK_TRANSFER_MANAGE: "invt:stk-trf:m",

  ADMIN_COMPANY_MANAGE: "sys-cfg:comp:m", // that has to change with cfg:comp:m
  ADMIN_BUILD_INFO:  "sys-cfg:bld:info",
  ADMIN_SERVER_VIEW: "cfg:srv:v",
  ADMIN_SERVER_MANAGE: "cfg:srv:m",
  ADMIN_PACKAGE_VIEW: "cfg:pkg:v",
  ADMIN_PACKAGE_MANAGE: "cfg:pkg:m",
  ADMIN_ZONE_VIEW: "cfg:zn:v",
  ADMIN_ZONE_MANAGE: "cfg:zn:m",
  ADMIN_DISTRIBUTOR_VIEW: "cfg:dtr:v",
  ADMIN_DISTRIBUTOR_MANAGE: "cfg:dtr:m",
  ADMIN_LEGAL_OFFICE_VIEW: "cfg:lgl-ofc:v",
  ADMIN_LEGAL_OFFICE_MANAGE: "cfg:lgl-ofc:m",
  ADMIN_SUPPORT_OFFICE_VIEW: "cfg:sup-ofc:v",
  ADMIN_SUPPORT_OFFICE_MANAGE: "cfg:sup-ofc:m",
  ADMIN_ZONE_COMMISSION_RULE_VIEW: "cfg:comms-rule:v",
  ADMIN_ZONE_COMMISSION_RULE_MANAGE: "cfg:comms-rule:m",
  ADMIN_MODULE_CONFIG_VIEW: "cfg:app-cfg:v",
  ADMIN_MODULE_CONFIG_MANAGE: "cfg:app-cfg:m",
  ADMIN_DATA_RESTRICTION_VIEW: "cfg:data-rst:v",
  ADMIN_DATA_RESTRICTION_MANAGE: "cfg:data-rst:m",
  ADMIN_INVOICE_POLICY_RULE_VIEW: "cfg:inv-rul:v",
  ADMIN_INVOICE_POLICY_RULE_MANAGE: "cfg:inv-rul:m",
  ADMIN_PACKAGE_WHITELIST_VIEW: "cfg:pkg-wl:v",
  ADMIN_PACKAGE_WHITELIST_MANAGE: "cfg:pkg-wl:m",
  ADMIN_ZONE_USER_VIEW: "cfg:zn-usr:v",
  ADMIN_ZONE_USER_MANAGE: "cfg:zn-usr:m",
  ADMIN_PAYMENT_GATEWAY_VIEW: "cfg:paygw:v",
  ADMIN_PAYMENT_GATEWAY_MANAGE: "cfg:paygw:m",
  ADMIN_NAS_VIEW: "cfg:nas:v",
  ADMIN_NAS_MANAGE: "cfg:nas:m",
  ADMIN_IPMGR_VIEW: "cfg:ipmgr:v",
  ADMIN_IPMGR_MANAGE: "cfg:ipmgr:m",
  ADMIN_COMMON_DELETE: "cfg:common:d",

  ADMIN_IDENTITY_USER_CREATE: "cfg:idn-usr:c",
  ADMIN_IDENTITY_USER_UPDATE: "cfg:idn-usr:u",
  ADMIN_IDENTITY_USER_VIEW: "cfg:idn-usr:v",
  ADMIN_IDENTITY_USER_MANAGE: "cfg:idn-usr:m",
  ADMIN_IDENTITY_USER_GROUP_VIEW: "cfg:idn-usr-grp:v",
  ADMIN_IDENTITY_USER_GROUP_MANAGE: "cfg:idn-usr-grp:m",

  SYSTEM_ADMIN_COMPANY_CREATE: "sys-cfg:comp:c",
  SYSTEM_ADMIN_COMPANY_MANAGE: "sys-cfg:comp:m",
  SYSTEM_ADMIN_CACHE_VIEW: "cache:v",

  TV_CHANNEL_VIEW: "tv:ch:v",
  TV_CHANNEL_MANAGE: "tv:ch:m",

  LOG_SEARCH_VIEW: "log:srch:v",

};

/**
 * Get all permissions
 */
export const getAllPermissions = () => Object.values(PERMISSIONS);

/**
 * Get permission count
 */
export const getPermissionCount = () => Object.keys(PERMISSIONS).length;

export default PERMISSIONS;
